/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useState } from 'react';
import {
  CpdsAccordionHeading,
  CpdsAccordionStyleTag,
  CpdsAccordionBody,
  CpdsAccordionTitle,
  CpdsAccordionLabel,
  CpdsAccordionBodyContent,
  CpdsAccordionBodyHeader,
} from './styles/cpds-accordion-style';
import { CpdsAccordionProps } from './typings';
import { checkValue } from 'components/common/helper';
import { CpdsAccordionTypes } from 'components/common/cpds/cpds-accordion/constants';
import { themeStyleClass, themeToken } from '../utils/cpds-utils';
import { Cpds } from '@Cpds.Ui';
import { ThemeContext } from 'styled-components';
import { ClickStreamEventConstants, ClickStreamEventType } from 'src/utils/event-wrapper';

const CpdsAccordion: React.FC<CpdsAccordionProps> = (props) => {
  const {
    domRef,
    exClasses,
    styleOverrides,
    children,
    heading,
    customBody,
    label,
    type = CpdsAccordionTypes.LONG,
    maxHeight,
    themeTypography,
    defaultBorders = true,
    manualExpand = false,
    manualOverride = undefined,
    chevronIconSize = {
      width: '12',
      height: '12',
    },
  } = props;
  const [expand, setExpand] = useState(false);
  const className = themeStyleClass('cpds-accordion', themeTypography, exClasses);
  const themeContext: any = useContext(ThemeContext);
  const cpds = themeContext?.styles?.cpds;
  const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

  const shouldExpand = manualOverride !== undefined ? manualExpand : expand;

  const chevronIconStyles = {
    transition: 'transform 1.2s ease-in-out',
    transform: `${shouldExpand ? 'rotateX(180deg)' : 'rotateX(0deg)'}`,
  };

  return (
    <CpdsAccordionStyleTag className={className} ref={domRef} styleOverrides={styleOverrides}>
      <CpdsAccordionHeading
        className="cpds-accordion-heading"
        defaultBorders={defaultBorders}
        onClick={manualOverride !== undefined ? () => manualOverride() : () => setExpand((prev) => !prev)}
        expand={shouldExpand}
      >
        {type === CpdsAccordionTypes.CUSTOM ? (
          <>{typeof heading === 'string' ? heading : heading(shouldExpand)}</>
        ) : (
          <>
            {checkValue(label) && type === CpdsAccordionTypes.SHORT && <CpdsAccordionLabel>{label}</CpdsAccordionLabel>}
            <CpdsAccordionTitle type={type}>{heading}</CpdsAccordionTitle>
          </>
        )}
        <Cpds.Icon
          id={heading as string}
          name="chevron-down"
          customSize={chevronIconSize}
          color={token.accordion_primary_text_color || '#0C0E1C'}
          styleOverrides={chevronIconStyles}
        />
      </CpdsAccordionHeading>
      <CpdsAccordionBody
        className="cpds-accordion-body"
        defaultBorders={defaultBorders}
        expand={shouldExpand}
        type={type}
        maxHeight={maxHeight}
      >
        {type === CpdsAccordionTypes.CUSTOM ? (
          <>{customBody ? (typeof customBody === 'string' ? customBody : customBody(shouldExpand)) : children}</>
        ) : (
          <>
            {checkValue(label) && type === CpdsAccordionTypes.LONG && (
              <CpdsAccordionBodyHeader>
                <CpdsAccordionLabel>{label}</CpdsAccordionLabel>
                <CpdsAccordionTitle type={CpdsAccordionTypes.SHORT}>{heading}</CpdsAccordionTitle>
              </CpdsAccordionBodyHeader>
            )}
            <CpdsAccordionBodyContent>{children}</CpdsAccordionBodyContent>
          </>
        )}
      </CpdsAccordionBody>
    </CpdsAccordionStyleTag>
  );
};

export default CpdsAccordion;
